import { render } from "./basic-modal.vue?vue&type=template&id=0d193ca0&scoped=true"
import script from "./basic-modal.vue?vue&type=script&lang=js"
export * from "./basic-modal.vue?vue&type=script&lang=js"

import "./basic-modal.vue?vue&type=style&index=0&id=0d193ca0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d193ca0"]])

export default __exports__